export const TAGS = ["Boleto", "Comunicado", "Contrato", "Estatuto", "Outro"];

export const Row = ({ label, value }) => (
  <div className="flex justify-between gap-4">
    <span className="text-slate-500">{label}</span>
    <span className="font-medium text-slate-900 text-right">{value}</span>
  </div>
);

export const Label = ({ children }) => (
  <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">{children}</label>
);

// Blob responses wrap the JSON error body; unwrap it to show the server's reason.
export const blobErrorDetail = async (err, fallback) => {
  try {
    if (err?.response?.data instanceof Blob) {
      const parsed = JSON.parse(await err.response.data.text());
      if (parsed?.detail) return String(parsed.detail);
    } else if (err?.response?.data?.detail) {
      return String(err.response.data.detail);
    }
  } catch (parseErr) {
    console.warn("Falha ao ler detalhe do erro:", parseErr);
  }
  return fallback;
};

export const saveBlob = (data, filename, type) => {
  const url = window.URL.createObjectURL(new Blob([data], type ? { type } : undefined));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
